import { render, staticRenderFns } from "./tablesUnit.vue?vue&type=template&id=79d051c8&scoped=true"
import script from "./tablesUnit.vue?vue&type=script&lang=js"
export * from "./tablesUnit.vue?vue&type=script&lang=js"
import style0 from "./tablesUnit.vue?vue&type=style&index=0&id=79d051c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d051c8",
  null
  
)

export default component.exports